import { StatusCodes } from 'http-status-codes';
import React, { useState } from 'react';
import DisplayLocation from '~/src/components/common/DisplayLocation';
import DisplayQuantities from '~/src/components/common/DisplayQuantities';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import FnbApi from '~/src/services/api/FnbApi';
import ProductService from '~/src/services/logic/ProductService';

interface Props {
  pendingChange: any;
}
export default function FnbPendingChange({ pendingChange }: Props) {
  const [completed, setCompleted] = useState(pendingChange.completed);

  const toggleDone = async (): Promise<void> => {
    const res = await FnbApi.togglePendingDone(pendingChange.id);
    if (res.status === StatusCodes.NO_CONTENT) {
      setCompleted(!completed);
    }
  };

  const cugtin = ProductService.getCuGtin(pendingChange.product.packagedProducts);

  return (
    <div>
      <span>[{completed ? 'V' : 'X'}]</span>
      <span>
        <ButtonComponent size="sm" title={`${completed ? 'undo' : 'done'}`} onClick={toggleDone} />
      </span>
      <span>{pendingChange.uniqueNumber}</span>
      <span>
        <DisplayQuantities
          duQuantity={pendingChange.duQuantity}
          dpQuantity={pendingChange.dpQuantity}
          cuQuantity={pendingChange.cuQuantity}
        />
      </span>
      <span>{pendingChange.type} </span>
      <span>CU {cugtin}</span>
      {/* <span>
        <DisplayLocation chamber={5} letter="B" column={12} level={1} />
      </span> */}
      <span>{pendingChange?.product?.genericProduct?.name}</span>
    </div>
  );
}
